const colors = {
    red: '#F44336',
    pink: '#E91E63',
    purple: '#9C27B0',
    violet: '#673AB7',
    'dark-blue': '#3F51B5',
    blue: '#2196F3',
    'light-blue': '#03A9F4',
    'swimming-pool-blue': '#00BCD4',
    'dark-green': '#009688',
    green: '#4CAF50',
    'light-green': '#8BC34A',
    'golden-green': '#CDDC39',
    'light-yellow': '#FFEB3B',
    yellow: '#FFC107',
    bronze: '#FF9800',
    orange: '#FF5722',
    brown: '#795548',
    gray: '#9E9E9E',
    'dark-gray': '#607D8B',
    black: '#000000',
    white: '#FFFFFF',
}

const colorList = [
    // '#EEEEEE',
    '#F44336',
    '#E91E63',
    '#9C27B0',
    '#673AB7',
    '#3F51B5',
    '#2196F3',
    '#03A9F4',
    '#00BCD4',
    '#009688',
    '#4CAF50',
    '#8BC34A',
    '#CDDC39',
    '#FFEB3B',
    '#FFC107',
    '#FF9800',
    '#FF5722',
    '#795548',
    '#9E9E9E',
    '#607D8B',
]

const chartColors = [
    "#7c37c2",
    "#a94bbd",
    '#c966bb',
    '#e084be',
    "#f0a5c6", 
    "#fac6d5", 
    "#ffe8eb", 
    "#ffdbdb", 
    "#ffcec5",  
    "#ffc4ab",
    "#ffbc8c",
    "#ffb76c",
    "#ffb548",
]

const barColors = [
    "#7c37c2",
    "#a94bbd",
    '#c966bb',
    '#e084be',
    "#f0a5c6", 
    "#fac6d5", 
    "#ffe8eb", 
    "#ffdbdb", 
    "#ffcec5",  
    "#ffc4ab",
    "#ffbc8c",
    "#ffb76c",
    "#ffb548",
]

const speedometerColors = [
    "#f0a5c6",
    '#c966bb',
    "#7c37c2",
    '#ff9d0c',
]

const abcColors = [
    "#7c37c2",
    '#c966bb',
    "#f0a5c6",
]

export default {
    colors,
    colorList,
    chartColors,
    speedometerColors,
    barColors,
    abcColors
}